import type { ImgHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

type CustomIconProps = {
    src: string;
    alt?: string;
    className?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'className'>;

const CustomIcon = ({ src, alt, className = '', ...props }: CustomIconProps) => {
    return (
        <img
            src={src}
            alt={alt}
            className={cn('h-24 w-24 lg:h-32 lg:w-32', className)}
            {...props}
        />
    );
};

export default CustomIcon;
